import $ from 'jquery';
import Slider from 'blocks/slider/slider';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-showcase-slide',
			dom: {
				slider: '.js-showcase-slide-slider',
				config: '.js-showcase-slide-config',
				toggle: '.js-showcase-slide-toggle'
			},
			classes: {
				config: {
					state: {
						open: 'b-showcase-slide__config_state_open'
					}
				}
			},
			slider: {
				el: '.js-showcase-slide-slider-slider',
				dom: {
					slide: '.js-showcase-slide-slider-slide',
					control: '.js-showcase-slide-slider-control',
					page: '.js-showcase-slide-slider-page'
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		return this;
	}

	getDom() {
		this.$config = this.$el.find(this.options.dom.config);
		this.$toggle = this.$el.find(this.options.dom.toggle);
		this.$slider = this.$el.find(this.options.dom.slider);
		return this;
	}


	configToggle() {
		this.$config.toggleClass(this.options.classes.config.state.open);
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$toggle.on('click', this.configToggle.bind(this));
			this.options.slider.el = this.$slider;
			this.slider = new Slider(this.options.slider).render();
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/showcase/slide/slide.js